module.exports = __webpack_public_path__ + "static/img/IN@2x.822a5681.jpg";